// extracted by mini-css-extract-plugin
export default {"imageWrapper":"rG-z","twoColumnImage":"sG-z"};